<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Lists</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="toggleCollapse"
                        >
                            <i
                                :class="changeIcon(collapse)"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <vue-slide-up-down
                    :active="collapse"
                    :duration="durationCollapse"
                >
                    <div v-if="!isListsFetching">
                        <div
                            v-if="!dataLength"
                            class="box-body with-border clearfix"
                        >
                            <p>There are no Lists in the system.</p>
                        </div>
                        <div v-else>
                            <div
                                class="box-body with-border clearfix"
                                @click="preventEnter"
                                @keydown="preventEnter"
                            >
                                <BadgeTotal
                                    :value="lists.total"
                                    color="gray"
                                    :label="`${$t('total')}: `"
                                />

                                <pagination
                                    :class="isDisabled()"
                                    :data="lists"
                                    :limit="$root.paginator.settings.limit"
                                    :size="$root.paginator.settings.size"
                                    class="pull-right no-margin vue-pagination"
                                    show-disabled
                                    @pagination-change-page="getDataLists"
                                >
                                    <span slot="prev-nav">
                                        <i class="fa fa-angle-double-left"></i>
                                    </span>
                                    <span slot="next-nav">
                                        <i class="fa fa-angle-double-right"></i>
                                    </span>
                                </pagination>
                            </div>
                            <div class="box-body table-responsive no-padding">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Info</th>
                                            <th>Price</th>
                                            <th>Custom ID</th>
                                            <th>Category</th>
                                            <th>Statistic</th>
                                            <th>Status</th>
                                            <th class="text-right">Created At</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="list in lists.data"
                                            :key="list.id"
                                        >
                                            <td>{{ list.id }}</td>
                                            <td>
                                                <ListItemsBadges :rows="infoRowData(list, countryTypes)" />
                                            </td>
                                            <td>{{ '$' + list.price_prepared_value }}</td>
                                            <td>
                                                <code>{{ list.custom_id }}</code>
                                            </td>
                                            <td>
                                                <a
                                                    v-if="!isUserOrPublisher"
                                                    :href="getRoute(list.category.id, 'category')"
                                                >
                                                    {{ list.category.name }}
                                                </a>
                                                <span v-else>{{ list.category.name }}</span>
                                            </td>
                                            <td>
                                                <img
                                                    v-show="!isLoadedStats"
                                                    alt="Preloader"
                                                    class="table-row-preloader"
                                                    rel="preload"
                                                    src="/img/table-row-preloader.gif"
                                                />
                                                <ListItemsBadges
                                                    v-show="isLoadedStats"
                                                    :rows="staticsRowData(list)"
                                                    :sizable="true"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-show="!isLoadedStatus"
                                                    alt="Preloader"
                                                    class="table-row-preloader"
                                                    rel="preload"
                                                    src="/img/table-row-preloader.gif"
                                                />
                                                <ListItemsBadges
                                                    v-show="isLoadedStatus"
                                                    :rows="statusRowData(list)"
                                                    :sizable="true"
                                                />
                                            </td>
                                            <td class="text-right">{{ list.created_at }}</td>
                                            <td class="text-right">
                                                <span v-if="!list.is_archived && !isUserOrPublisher">
                                                    <ModalContent
                                                        :id="list.id"
                                                        :route="routes"
                                                        type="archive"
                                                        @click="isShowModal = true"
                                                        @modalEmitData="emittedModalData"
                                                    />
                                                    <ModalContent
                                                        v-if="list.is_lookup_available"
                                                        :id="list.id"
                                                        :route="routes"
                                                        type="lookup"
                                                        @click="isShowModal = true"
                                                        @modalEmitData="emittedModalData"
                                                    />
                                                    <ModalContent
                                                        v-if="list.is_lookup_resettable"
                                                        :id="list.id"
                                                        :route="routes"
                                                        type="lookupRest"
                                                        @click="isShowModal = true"
                                                        @modalEmitData="emittedModalData"
                                                    />
                                                    <a
                                                        :href="getRoute(list.id, 'export')"
                                                        class="btn btn-sm btn-warning"
                                                    >
                                                        <i class="fa fa-download"></i>
                                                        <span class="sr-only">Export</span>
                                                    </a>
                                                    <a
                                                        :href="getRoute(list.id, 'edit')"
                                                        class="btn btn-sm btn-primary"
                                                    >
                                                        <i class="fa fa-edit"></i>
                                                        <span class="sr-only">Edit</span>
                                                    </a>
                                                </span>
                                                <a
                                                    :href="getRoute(list.id, 'show')"
                                                    class="btn btn-sm btn-info"
                                                >
                                                    <i class="fa fa-eye"></i>
                                                    <span class="sr-only">Show</span>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                class="box-footer clearfix"
                                @click="preventEnter"
                                @keydown="preventEnter"
                            >
                                <pagination
                                    v-if="!isListsFetching && lists.total"
                                    :class="isDisabled()"
                                    :data="lists"
                                    :limit="$root.paginator.settings.limit"
                                    :size="$root.paginator.settings.size"
                                    class="pull-right no-margin vue-pagination"
                                    show-disabled
                                    @pagination-change-page="getDataLists"
                                >
                                    <span slot="prev-nav">
                                        <i class="fa fa-angle-double-left"></i>
                                    </span>
                                    <span slot="next-nav">
                                        <i class="fa fa-angle-double-right"></i>
                                    </span>
                                </pagination>
                            </div>
                        </div>
                        <main-modal-form
                            v-if="isShowModal"
                            :modal="emittedModalValues"
                            @close="isShowModal = false"
                            @updateData="modalData($event)"
                        />
                    </div>
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ListItemsBadges from '../../subcomponents/ListItemsBadges';
import ModalContent from '../../subcomponents/modals-content/ModalListsContent';
import EventBus from '../../../event-bus';

export default {
    components: {
        BadgeTotal,
        ListItemsBadges,
        ModalContent,
    },
    props: {
        queryFilter: {
            type: String,
            default: '',
        },
        entityName: {
            type: String,
            default: '',
        },
        entityId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            lists: {},
            countryTypes: {},
            pageNumber: this.$route.query['page'],
            routes: {
                category: '/lists/categories/:id:/show',
                show: '/lists/:id:',
                edit: '/lists/:id:/edit',
                archive: '/lists/:id:/archive-vue',
                lookup: '/lists/:id:/lookup-vue',
                lookupRest: '/lists/:id:/reset-lookup-vue',
                export: '/lists/:id:/export',
            },
            isListsFetching: true,
            isLoadedStats: false,
            isLoadedStatus: false,
            isUserOrPublisher: true,
            isShowModal: false,
            addQuery: {},
            emittedModalValues: {},
            disableFilter: false,
            toggleCheck: true,
            collapse: true,
            durationCollapse: 700,
        };
    },
    computed: {
        dataLength: function () {
            return this.lists.data.length;
        },
        pageDatesRange: function () {
            return this.$route.query['filter[dates]'];
        },
    },
    watch: {
        pageDatesRange: function () {
            this.pageNumber = 1;
            this.getDataLists(this.pageNumber);
        },
        toggleCheck: function () {
            if (this.isLoadedStatus === true && this.isLoadedStats === true) {
                this.emitDisableFilter(false);
            }
        },
    },
    mounted() {
        this.getDataLists(this.pageNumber);
    },
    methods: {
        emitDisableFilter(value) {
            EventBus.$emit('disableFilterList', {
                disableFilter: value,
            });
        },
        emittedModalData(value) {
            this.emittedModalValues = value;
        },
        getDataLists(page = 1) {
            let query = this.queryFilter ? this.queryFilter + '&page=' + page : '?page=' + page;
            this.isLoadedStats = false;
            this.isLoadedStatus = false;
            this.isListsFetching = true;
            this.emitDisableFilter(true);

            axios
                .get('/lists/' + this.entityName + '/' + this.entityId + '/lists-data' + query)
                .then((response) => {
                    if (String(page) !== String(this.$route.query.page)) {
                        this.$router.push({ query: Object.assign({}, this.$route.query, { page: String(page) }) });
                    }

                    if (page > response.data.lists.last_page) {
                        return this.getDataLists();
                    }

                    this.addQuery = response.data.addQuery;
                    this.lists = response.data.lists;
                    this.countryTypes = response.data.countryTypes;
                    this.isUserOrPublisher = response.data.isUserOrPublisher;
                    this.isListsFetching = false;
                    let ids = _.map(this.lists.data, 'id');
                    if (ids.length) {
                        this.getStatsLists(this.entityId, ids);
                    } else {
                        this.emitDisableFilter(false);
                    }
                })
                .catch(() => {});
        },
        getStatsLists(entity, ids) {
            this.isLoadedStatus = false;
            this.isLoadedStats = false;
            let query = this.queryFilter ? this.queryFilter + '&ids=' + ids : '?ids=' + ids;
            axios
                .get('/lists/lists-stats' + query)
                .then((response) => {
                    this.listsStats = response.data.stats;
                    let sort = _.merge(_.keyBy(this.lists.data, 'id'), _.keyBy(this.listsStats, 'id'));
                    this.lists.data = _.orderBy(sort, ['id'], ['desc']);
                    this.isLoadedStats = true;
                    this.toggleCheck = !this.toggleCheck;
                })
                .catch(() => {});
            axios
                .get('/lists/lists-status?ids=' + ids)
                .then((response) => {
                    this.ListsStatus = response.data.status;
                    let sort = _.merge(_.keyBy(this.lists.data, 'id'), _.keyBy(this.ListsStatus, 'id'));
                    this.lists.data = _.orderBy(sort, ['id'], ['desc']);
                    this.isLoadedStatus = true;
                    this.toggleCheck = !this.toggleCheck;
                })
                .catch(() => {});
        },
        modalData: function (e) {
            this.isShowModal = false;
            _.merge(_.keyBy(this.lists.data, 'id'), _.keyBy({ 0: e }, 'id'));
        },
        preventEnter: function (event) {
            if (!this.isLoadedStatus || !this.isLoadedStats) {
                return event.preventDefault();
            }
        },
        getRoute: function (id, type) {
            let route = this.routes[type].replace(':id:', id);
            type === 'show' && this.queryFilter && (route += this.queryFilter);

            return route;
        },
        isDisabled: function () {
            return !this.isLoadedStatus || !this.isLoadedStats ? 'disabled-box' : '';
        },
        infoRowData: function (list, countryTypes) {
            return [
                {
                    name: 'Name:',
                    component: 'ValueEmpty',
                    items: [
                        {
                            value: list.name,
                        },
                    ],
                },
                {
                    name: 'File:',
                    component: 'ValueEmpty',
                    items: [
                        {
                            value: list.file ? list.file.original_name : null,
                            textNone: 'Lost',
                        },
                    ],
                },
                {
                    name: 'Country Type:',
                    component: 'ValueEmpty',
                    items: [
                        {
                            value: list.country_type_id ? countryTypes[list.country_type_id] : null,
                        },
                    ],
                },
            ];
        },
        staticsRowData: function (list) {
            let campaigns = [
                {
                    name: 'Campaigns',
                    component: 'BadgeTotal',
                    items: [
                        {
                            value: list.campaigns_count,
                            color: 'gray',
                        },
                    ],
                },
            ];
            list.campaigns_count &&
                campaigns.push(
                    {
                        name: 'Messages',
                        component: 'BadgeTotal',
                        items: [
                            { value: list.messages_count, title: 'Total', color: 'gray' },
                            { value: list.messages_sent, title: 'Sent', color: 'green' },
                            { value: list.messages_failed, title: 'Failed', color: 'red' },
                            { value: list.messages_blacklisted, title: 'Blacklisted', color: 'black' },
                        ],
                    },
                    {
                        name: 'Clicks',
                        component: 'BadgeTotal',
                        items: [
                            { value: list.percentage + '%', title: 'Percentage', color: 'light-blue' },
                            { value: list.clicks_count, title: 'Amount', color: 'aqua-active' },
                        ],
                    },
                    {
                        name: 'Revenue',
                        component: 'BadgeTotal',
                        items: [
                            { value: '$' + list.revenues_prepared_value, title: 'Amount', color: 'light-blue' },
                            { value: list.revenues_count, title: 'Count', color: 'aqua-active' },
                        ],
                    },
                    {
                        name: 'eCPM/EPC',
                        component: 'BadgeTotal',
                        items: [
                            { value: list.ecpm_prepared_value, title: 'eCPM', color: 'light-blue' },
                            { value: list.epc_prepared_value, title: 'epc', color: 'aqua-active' },
                        ],
                    }
                );
            return campaigns;
        },
        statusRowData: function (list) {
            return [
                {
                    name: 'Active',
                    component: 'ValueYesNo',
                    items: [
                        {
                            value: list.active,
                        },
                    ],
                },
                {
                    name: 'Status',
                    component: 'BadgeTotal',
                    items: [{ value: list.status_prepared_value, color: list.status_color }],
                },
                {
                    name: 'Lookup',
                    component: 'EmptyBadge',
                    items: [
                        {
                            value: list.status_lookup ? list.status_lookup_prepared_value : null,
                            color: list.status_lookup_color,
                        },
                    ],
                },
                {
                    name: 'Parsed',
                    component: 'BadgeTotal',
                    items: [{ value: list.has_file ? (list.file.rows_total !== null && list.file.rows_total !== undefined ? list.file.rows_total : list.file.rows_parsed) : 0, color: 'gray' }],
                },
                {
                    name: 'Contacts',
                    component: 'BadgeTotal',
                    items: [
                        { value: list.contacts_count || 0, title: 'Total', color: 'gray' },
                        { value: list.contacts_active || 0, title: 'Active', color: 'green' },
                        { value: list.contacts_inactive || 0, title: 'Inactive', color: 'red' },
                    ],
                },
            ];
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    },
};
</script>
